import $ from "jquery";

import Backbone from "backbone";
import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

import Flash from "shared/flash";
import Ajax from "shared/ajax";
import ExceptionHandling from "shared/logging/exception_handling";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("SignalExpressionOwner", {

    defaults: {
      name: '',
      description: '',
      expression: '',
      previouslyValidatedText: ''
    },

    initialize: function(attrs, { terminalMetaData }) {
      _.bindAll(this, "validate", "validateExpression");
      this.expressionTerminals = new app.Collections.ExpressionTerminals([], { terminalMetaData });

      this._addValidationListeners();
    },

    set: function(key, attributes, options) {
      if (key === 'errors' && attributes && attributes.expression && this._parenthesesAdded(attributes.expression)) {
        this._removeAttributesWithinHash('warnings', 'expression');
        this._addParenWarning();
        attributes.expression = [];
      }
      return Backbone.Model.prototype.set.call(this, key, attributes, options);
    },

    validate: function(attrs, options) {
      this.unset("errors");

      var errors = {};
      var trimmedName = $.trim(this.get('name'));

      if (trimmedName === "") {
        errors.name = "can't be blank";
      }

      if (this.voiceModel && this.requiresVoiceCondition() && !this.voiceModel.isValid()) {
        errors.expression = this.voiceModel.errorMessages();
      } else if (!this.expressionTerminals.isValid()) {
        errors.expression = this.expressionTerminals.errorMessages();
      }

      if ($.isEmptyObject(errors)) {
        return null;
      } else {
        this.set('errors', errors);
        return errors;
      }
    },

    requiresVoiceCondition: function() {
      return (this.voiceModel.isRequired(this.features));
    },

    validateExpression: function(errorCallback, skipValidations) {
      if (this.get('expression') && this._expressionHasChanged()) {
        this.trigger('validating:true');
        this.set('previouslyValidatedText', this.get('expression'));
        this._removeAttributesWithinHash('errors', 'expression');
        this._removeAttributesWithinHash('warnings', 'expression');

        if (skipValidations || this.expressionTerminals.isValid()) {
          this._fetchSignalExpressionOwner(errorCallback);
        } else {
          this._addAttributesWithinHash('errors', 'expression', this.expressionTerminals.errorMessages());
          this.trigger('validating:false');
        }
      }
    },

    _fetchSignalExpressionOwner: function() {
      throw new Error("_fetchSignalExpressionOwner must be implemented by subclass");
    },

    _addValidationListeners: function() {
      this.listenTo(this.expressionTerminals, 'validate', function() {
        if (this.expressionTerminals.isValid()) { this._updateAndvalidateExpression(); }
      });
    },

    _updateAndvalidateExpression: function() {
      this.set('expression', this.expressionTerminals.expressionText());
      this.validateExpression();
    },

    _processSuccessfulExpressionSync: function(response) {
      if (!_.isArray(response.expression_nodes)) {
        ExceptionHandling.logError("validateExpression response did not contain an expression_nodes array. Got: " + JSON.stringify(response));
        return;
      }

      this.expressionTerminals.reset(response.expression_nodes);
      this.trigger('validating:false');
    },

    _removeAttributesWithinHash: function(attribute, key) {
      this.set(attribute,
        _.omit(
          (this.get(attribute) || {}),
          key
        )
      );
    },

    _processExpressionSyncWithErrors: function(response, errorCallback) {
      if (response.status === 422 && response.responseJSON && response.responseJSON.errors) {
        if (this._parenthesesAdded(response.responseJSON.errors)) {
          if (!this._expressionHasChanged()) {
            var newExpression = response.responseJSON.expression_text;

            if (newExpression) {
              this.set('expression', newExpression);
              this.expressionTerminals.reset(response.responseJSON.expression_nodes);

              this._addParenWarning();
            } else {
              ExceptionHandling.logError("Got back a validation error about parentheses being added, but no 'expression_text' field found");
              Flash.showError(Ajax.defaultErrorMessageWithTimestamp(response));
            }
          }
        } else {
          this._addAttributesWithinHash('errors', 'expression', response.responseJSON.errors);

          if (errorCallback) {
            errorCallback();
          }
        }
      } else {
        var parsedResponse = Ajax.parseResponse(response);
        Flash.showError(parsedResponse.message);
      }

      this.trigger('validating:false');
    },

    _addParenWarning: function() {
      this._addAttributesWithinHash(
        "warnings",
        "expression",
        "We've added parentheses to validate this rule. These changes can be modified if needed."
      );
    },

    _addAttributesWithinHash: function(attribute, key, value) {
      var keyValueHash = {};
      keyValueHash[key] = value;
      var mergedValues = _.extend(
        {},
        this.get(attribute),
        keyValueHash
      );
      this.unset(attribute);
      this.set(attribute, mergedValues);
    },

    _parenthesesAdded: function(errors) {
      return _.any(errors, function(val) {
        return val.match(/parentheses/);
      });
    },

    _expressionHasChanged: function() {
      return this.get('previouslyValidatedText') !== this.get('expression');
    }
  });
});
